import { TextField } from "../fields/textField";
import { toggleValidStep } from '../../actions';
import { EVENT_NAME_FIELDS_VALIDATE, EVENT_NAME_STEP_VALIDATE } from "../../helpers/consts";

export class PersonalInformationStep {
    /**
     * Component that handles the personal information step.
     * @constructor
     * @param {Object} options
     * @param {Store} options.store
     * @param {string} options.id - Step id string
     */
    constructor(options) {
        this.store = options.store;
        this.isValid = false;
        this.id = options.id;
        this.modalConfirm = false;
        this.createStep();
        this.update();
        this.store.subscribe(this.update.bind(this));
    }

    createStep() {
        const $fieldSet = document.createElement('div');
        const fieldSetHTML = `
<div class="fieldset">
    <div class="row">
        <div class="col-12 form-group field col--field--first-name"></div>
        <div class="col-12 form-group field col--field--insertion"></div>
        <div class="col-12 form-group field col--field--last-name"></div>
    </div>
</div>
        `;
        $fieldSet.classList.add('fieldset');
        $fieldSet.innerHTML = fieldSetHTML;

        this.$firstNameField = new TextField({
            store: this.store,
            stepId: this.id,
            id: 'firstName',
            label: __('First Name'),
            $context: $fieldSet,
        });

        this.$insertionField = new TextField({
            store: this.store,
            stepId: this.id,
            id: 'insertion',
            label: __('Insertion'),
            required: false,
            $context: $fieldSet,
        });

        this.$lastNameField = new TextField({
            store: this.store,
            stepId: this.id,
            id: 'lastName',
            autocomplete: 'off',
            label: __('Last name'),
            $context: $fieldSet,
        });

        $fieldSet.querySelector('.col--field--first-name').appendChild(this.$firstNameField.render());
        $fieldSet.querySelector('.col--field--insertion').appendChild(this.$insertionField.render());
        $fieldSet.querySelector('.col--field--last-name').appendChild(this.$lastNameField.render());

        $fieldSet.addEventListener(EVENT_NAME_STEP_VALIDATE, this.validateStep.bind(this));
        $fieldSet.addEventListener(EVENT_NAME_FIELDS_VALIDATE, () => {
            this.$firstNameField.validate();
            this.$lastNameField.validate();
        });

        this.$el = $fieldSet;
        this.state = this.store.getState();

        this.validateStep();
    }

    validateStep() {
        this.isValid = this.$firstNameField.valid() && this.$lastNameField.valid();
        this.store.dispatch(toggleValidStep(this.id, this.isValid));
    }

    render() {
        return this.$el;
    }

    update() {
        this.state = this.store.getState();
    }
}

export default PersonalInformationStep;
